import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Microsoft365 extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <polygon points="22.01 22 22.008 21.999 22.008 2.061 14.864 0 2.022 4.822 1.99 4.828 1.992 19.245 6.374 17.529 6.374 5.8 14.864 3.77 14.863 21.015 1.999 19.245 14.863 23.995 14.863 24 22.008 22.023 22.008 22 22.01 22" />
      </svg>
    );
  }
}

export default Microsoft365;
